export const SECTION_CATEGORIES = {
  WELDED_BEAMS: 'Welded beams WB',
  WELDED_COLUMNS: 'Welded columns WC',
  UNIVERSAL_BEAMS: 'Universal beams UB',
  UNIVERSAL_COLUMNS: 'Universal columns UC',
  PARALLEL_FLANGE_CHANNELS: 'Parallel flange channels PFC',
  EQUAL_ANGLES: 'Equal angles EA',
  UNEQUAL_ANGLES: 'Unequal angles UA',
  CIRCULAR_HOLLOW_SECTIONS: 'Circular hollow sections CHS',
  RECTANGULAR_HOLLOW_SECTIONS: 'Rectangular hollow sections RHS',
  SQUARE_HOLLOW_SECTIONS: 'Square hollow sections SHS',
};

export const STANDARDS = {
  AUST300: 'Aust300',
  AUST350: 'Aust350',
};

export const AVAILABILITY_STATUS = {
  COMMON: 'Common',
  SPECIAL: 'Special',
  LEGACY: 'Legacy',
  OBSOLETE: 'Obsolete',
}; 